import { useId } from 'react';
import { Link } from 'react-router';
import { Trans, useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { Reveal } from 'src/components/reveal';
import { mergeClasses } from 'src/utils/merge-classes';
import { useContactForm } from 'src/hooks/use-contact-form';

export function ContactForm() {
  const { t } = useTranslation('contact');
  const { status, submitting, handleSubmit } = useContactForm();

  const nameId = useId();
  const emailId = useId();
  const companyId = useId();
  const messageId = useId();

  return (
    <Reveal className="form-card">
      <form noValidate onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="field">
            <label htmlFor={nameId}>{t('form.name')}</label>
            <input required id={nameId} name="name" type="text" autoComplete="name" />
          </div>
          <div className="field">
            <label htmlFor={emailId}>{t('form.email')}</label>
            <input required id={emailId} name="email" type="email" autoComplete="email" />
          </div>
          <div className="field full">
            <label htmlFor={companyId}>{t('form.company')}</label>
            <input type="text" id={companyId} name="company" autoComplete="organization" />
          </div>
          <div className="field full">
            <label htmlFor={messageId}>{t('form.message')}</label>
            <textarea
              required
              id={messageId}
              name="message"
              placeholder={t('form.messagePlaceholder')}
            />
          </div>
          <div className="field full">
            <label className="consent">
              <input required name="consent" type="checkbox" />
              <span>
                <Trans
                  ns="contact"
                  i18nKey="form.consent"
                  components={{ privacy: <Link to={paths.privacy} /> }}
                />
              </span>
            </label>
          </div>
          <div className="field full">
            <button type="submit" disabled={submitting} className="btn btn-day-dark">
              {t('form.submit')} <span className="arrow">→</span>
            </button>
            <output aria-live="polite" className={mergeClasses('form-status', status?.tone)}>
              {status?.message}
            </output>
          </div>
        </div>
      </form>
    </Reveal>
  );
}
